import Colors from "enums/Colors";
import styled from "styled-components";



const MenuTypePackageStyle = {

    Container: styled.div<{ hidden?: boolean }>`
        display: ${props => (props.hidden ? 'none' : 'flex')};
        flex-direction: column;
        position: fixed;
        top: 128px;
        right: 0;
        height: 183px;
        align-items: end;
        justify-content: center;
        gap: 24px;
        width: 240px;
        z-index: 10;
    `,

    Content: styled.button<{ isSelected: boolean }>`
        background-color: ${props => props.isSelected ? "#f4f4f4" : '#333333' };
        color: ${props => props.isSelected ? Colors.Blue : 'white'};
        width: ${props => props.isSelected ? '100%' : '80px'};
        height: 60px;
        display: flex;
        align-items: center;
        padding-left: 12px;
        border-bottom-left-radius: 20px;
        border-top-left-radius: 20px;
        transition: all 0.3s ease-in;
        gap: 10px;
        cursor: pointer;
        border: none;

        .spanContainer {
            display: none;
        }

        &:hover {
            background-color: #F4F4F4;
            color: ${Colors.Blue};
            width: 100%;

            .spanContainer {
                display: block;
            }
        }


    `


}


export default MenuTypePackageStyle;
